var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancerFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 76,
    viewBox: "0 0 70 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H60C65.5229 0 70 4.47715 70 10V66C70 71.5229 65.5229 76 60 76H10C4.47715 76 0 71.5229 0 66V10Z",
    fill: "#F9FDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_1347)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_349_1347)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_349_1347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9909 26.2182C28.0159 20.1176 19.1472 25.4778 19.0018 32.7444C18.9647 34.5964 19.4993 36.4003 20.5634 38.0633H27.4607L28.6874 36.0186C29.0437 35.425 29.9057 35.4059 30.2821 35.9977L32.8705 40.0651L36.6435 32.1C36.9726 31.405 37.9532 31.3829 38.3161 32.0569L41.5503 38.0633H49.4184C55.2468 28.954 43.7279 18.5766 34.9909 26.2182Z",
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1656 39.4452L37.5448 34.578L33.8387 42.4018C33.5234 43.0674 32.5961 43.1252 32.2007 42.5038L29.5152 38.2839L28.7957 39.4831C28.6263 39.7654 28.3212 39.9382 27.9919 39.9382H22.0469C22.2332 40.1332 21.24 39.142 34.3302 52.1644C34.6958 52.5281 35.2868 52.5282 35.6525 52.1644C48.5412 39.3423 47.7498 40.1328 47.9358 39.9382H40.9909C40.646 39.9382 40.329 39.7489 40.1656 39.4452Z",
    fill: "#0061FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_1347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(19 22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_349_1347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(19 22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_349_1347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28.8744,
    fill: "white",
    transform: "translate(19 23.5627)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancerFree);
export default __webpack_public_path__ + "static/media/cancer-free.5d668a0751baac62fca3d3721aedd311.svg";
export { ForwardRef as ReactComponent };